var ErrorMessageResults = {
    HIDE_ERROR_MESSAGE: 'HIDE_ERROR_MESSAGE',
    WAIT_PROMISE: 'WAIT_PROMISE',
    DISABLE_BUTTON: 'DISABLE_BUTTON',
    REPLACE_BUTTON_TO_LOADER: 'REPLACE_BUTTON_TO_LOADER'
};

var ErrorMessageEvents = {
    SHOW: 'ErrorMessage.Show',
    HIDE: 'ErrorMessage.Hide'
};

var ErrorMessage_Controller = function ($scope, $log) {

    $scope.data = null;
    $scope.$root.$on(ErrorMessageEvents.SHOW, function (event, data) {
        $log.debug(ErrorMessageEvents.SHOW, event, data);
        $scope.data = _.defaults(data, { iconClass: 'icon--error', buttonLabel: 'OK' });
    });
    $scope.$root.$on(ErrorMessageEvents.HIDE, function (event) {
        $log.debug(ErrorMessageEvents.HIDE, event);
        $scope.data = null;
    });

    $scope.buttonClickHandler = function () {
        if (!$scope.data.buttonHandler) {
            $log.debug("ErrorMessage :: Undefined 'buttonHandler'");
            return;
        }
        var result = $scope.data.buttonHandler();
        resultHandler(_.castArray(result));
    };

    function resultHandler(result) {

        if (_.includes(result, ErrorMessageResults.HIDE_ERROR_MESSAGE)) {
            $scope.data = null;
            return;
        }

        if (_.includes(result, ErrorMessageResults.REPLACE_BUTTON_TO_LOADER))
            $scope.data.showLoaderOnButton = true;
        else if (_.includes(result, ErrorMessageResults.DISABLE_BUTTON))
            $scope.data.buttonDisabled = true;

        if (_.includes(result, ErrorMessageResults.WAIT_PROMISE)) {
            var promise = _.find(result, function (o) {
                return _.isFunction(o.then) && _.isFunction(o.finally)
            });
            if (promise) promise.then(function (result) {
                $scope.data.buttonDisabled = false;
                $scope.data.showLoaderOnButton = false;
                resultHandler(result);
            })
        }
    }
};

ErrorMessage_Controller.$inject = ['$scope', '$log'];

var ErrorMessage_Link = function ($scope, $element, $attrs) {
};

module.exports = function () {
    return {
        replace: false,
        templateUrl: 'template/directives/error-message',
        restrict: 'E',
        link: ErrorMessage_Link,
        controller: ErrorMessage_Controller,
        scope: {
            options: '='
        }
    }
}

